import { render } from "./SignInPopup.vue?vue&type=template&id=4ff4e6ae&scoped=true"
import script from "./SignInPopup.vue?vue&type=script&lang=js"
export * from "./SignInPopup.vue?vue&type=script&lang=js"

import "./SignInPopup.vue?vue&type=style&index=0&id=4ff4e6ae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff4e6ae"]])

export default __exports__